if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();

        this.variantImage();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      variantImage() {
        const variants = this.querySelectorAll('[data-variant-option]');
        const imgPopup = document.querySelector('.variant-popup__hover .image__inner');
        variants.forEach(variant => {
          const img = document.createElement('img');
          img.setAttribute('data-option-value-id', variant.dataset.optionValueId);
          img.setAttribute('src', variant.dataset.imgSrc);
          imgPopup.append(img)
        })

        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(() => {
            document.querySelectorAll('.swatch-view-item').forEach(imgEle => {
              imgEle.addEventListener('mouseenter', function (e) {
                document.querySelector('.variant-popup__hover').classList.add('active');
                imgPopup.querySelectorAll('img').forEach(eleImg => {
                  eleImg.style.display = "none";
                })
                const optionValueId = e.target.getAttribute('option-value-id');
                const imgTag = imgPopup.querySelector(`[data-option-value-id="${optionValueId}"]`);
                imgTag.style.display = "block";
              });

              imgEle.addEventListener('mouseleave', function (e) {
                document.querySelector('.variant-popup__hover').classList.remove('active');
              })
            })
          }, 2000);
        })
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }

        const popupElement = document.querySelector('.product_variant_popup');

        if(target.dataset.imgSrc && target.dataset.imgSrc != null && target.dataset.imgSrc != "") {
          popupElement.querySelector('img').setAttribute('src', target.dataset.imgSrc);

          setTimeout(() => {
            if(window.innerWidth < 768) {
              popupElement.classList.add('active');
            }
          }, 1000);
        }
      }
    }
  );
}
